var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16.001,
    viewBox: "0 0 16 16.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Phone",
    d: "M517.352,359.659a.715.715,0,0,1,.6.4l1.312,3.063a.762.762,0,0,1,.054.258.74.74,0,0,1-.242.507l-1.657,1.357a11.781,11.781,0,0,0,4.845,4.845l1.356-1.657a.746.746,0,0,1,.509-.241.779.779,0,0,1,.257.052l3.062,1.312a.724.724,0,0,1,.405.606.894.894,0,0,1-.016.146l-.656,2.844a.689.689,0,0,1-.64.508,12.687,12.687,0,0,1-12.688-12.686v0a.689.689,0,0,1,.508-.639l2.844-.656a.807.807,0,0,1,.147-.017m.018-1h-.042a1.833,1.833,0,0,0-.329.039l-2.863.66a1.69,1.69,0,0,0-1.282,1.577,13.71,13.71,0,0,0,13.686,13.724,1.692,1.692,0,0,0,1.606-1.246l.665-2.881a1.921,1.921,0,0,0,.042-.343v-.044l0-.044a1.722,1.722,0,0,0-.966-1.445l-3.1-1.332a1.824,1.824,0,0,0-.619-.132l-.044,0-.043,0a1.733,1.733,0,0,0-1.191.564l-.019.02-.018.022-.816,1a10.743,10.743,0,0,1-3.318-3.318l1-.817a1.751,1.751,0,0,0,.606-1.226l0-.043,0-.044a1.739,1.739,0,0,0-.125-.6l-1.321-3.085a1.736,1.736,0,0,0-1.46-1l-.041,0Z",
    transform: "translate(-512.854 -358.658)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.099e643a99e067fa09135d86bfd092e8.svg";
export { ForwardRef as ReactComponent };